module.exports = __webpack_public_path__ + "img/4k.8f029854.svg";